import axios from "axios";
import { response } from "express";
import { ServerSideTypes } from "../component/common/OperationCommonTypes";
import { TypesOfData } from "../component/logisticCompound/types";
import OperationTypes from "../types";

export interface ILCFinancial {
  id: number,
  representativeAccountCode: string,
  clientIdentificationCode: string,
  clientAccountCode: string,
  zone: string,
  feesDued: boolean,
  rentalFiscalReceiptsCode: string,
  feesFiscalReceiptsCode: string,
  tenant: string
}

export interface ILCSupplier {
  bpCode: string,
  name: string,
  vatNumber: string,
  siren: string,
  siret: string,
  taxCode: string,
  address: string
}

export interface ILCEparking {
  id: number,
  identificationCode: string,
  status: string,
  address: string,
  streetNumber: string,
  certificationProtocolIdentificationCode: string,
  evaluationOutcome: string,
  note: string,
  requiredPower: number,
  effectivePower: number,
  chargingColumns: number,
  chargingColumnId: number,
  chargingColumnType: string,
  chargingPoints: number,
  tenant: string
}

export interface ILogisticCompound {
  id: number,
  name: string,
  identificationCode: string,
  oldIdentificationCode: string,
  bpCode: string,
  bpKind: OperationTypes.Domain,
  currentStatus: string,
  serviceType: OperationTypes.Domain[],
  fax: string,
  phoneNumber: string,
  cellPhoneNumber: string,
  email: string,
  currentAttribute: string,
  category: OperationTypes.Domain[],
  city17: string,
  longitude: string,
  latitude: string,
  branchManager: string,
  branchManagerCellPhoneNumber: string,
  brandName: string,
  areaManager: string,
  chargingSite: boolean,
  deliveryCollection: string,
  note: string,
  howToIta: string,
  howToEng: string,
  openingClosingHours: string,
  openingTimeMonFri: string,
  openingTimeSat: string,
  openingTimeSun: string,
  as400Code: string,
  financial: ILCFinancial,
  tenant: string,
  supplier: ILCSupplier,
  location: OperationTypes.Domain,
  eparking: ILCEparking,
}

const LogisticCompoundAction = () => {
  const baseUrl = ``;
  const getLogisticCompound = async (tenant:string, data: TypesOfData.SearchFuncTypes, params: ServerSideTypes.IParams) => {
    return await axios.get<ServerSideTypes.IResult<ILogisticCompound>>(`${baseUrl}/masterdatasupplier/logisticCompound/pagination`, {
      params: {
        tenant:tenant,
        ...data,
        ...params
      },
    }).then(
      response => response.data,
    );
  };

    const getByIdLogisticCompound =async (id: number, tenant:string) => {
      return await axios.get<TypesOfData.IByIdLogisticCompound>(`/masterdatasupplier/logisticCompound/${id}`, {params: {tenant:tenant}})
            .then(response => response.data)
    }

  const editLogisticCompound = async (
    id:number,
    tenant:string,
    data: TypesOfData.IByIdLogisticCompound 
  ) => {
    return await axios.put(
      `${baseUrl}/masterdatasupplier/logisticCompound/${id}`,
      data,
      {params: {tenant:tenant}}
    );
  };


  const exportLogisticCompound = async (tenant:string, data: TypesOfData.SearchFuncTypes) => {
    return await axios.get(
      `${baseUrl}/masterdatasupplier/logisticCompound/excel`,
      {params:{tenant,...data},
        responseType: "arraybuffer",
        headers: { "Access-Control-Allow-Origin": true },
      }
    );
  };

  return {
    getLogisticCompound,
    getByIdLogisticCompound,
    editLogisticCompound,
    exportLogisticCompound,
  };
};

export default LogisticCompoundAction;
